import React, { PropTypes } from 'react';
import { Link, IndexLink, browserHistory } from 'react-router';

import Message from '../Message/Message';
import ApprovalStatus from '../ApprovalStatus/ApprovalStatus';
import './RequestSummary.scss';

class RequestSummary extends React.Component {
    constructor(props) {
        super(props);
        // this.renderLatestMessage = this.renderLatestMessage.bind(this);
    }

    render() {
        const {bookInfo, requestInfo, isAdmin} = this.props;

        function renderLatestMessage() {
            if (requestInfo.messages) {
                var recentMessage = requestInfo.messages[requestInfo.messages.length - 1];
                if (recentMessage) {
                    return (
                        <div className="recent-message">
                            <Message message={recentMessage}/>
                        </div>
                    );
                }
            }
        }

        const userOrAdmin = isAdmin ? 'admin' : 'user';

        return (
            <Link className="request-summary-container" to={`/${userOrAdmin}/history/${requestInfo.requestId}`}>
                <div>
                    <div className="image-container">
                        <img src={bookInfo.imageLinks.small}/>
                    </div>
                    <div className="book-info">
                        <div className="title">{bookInfo.title.concat(', ', bookInfo.edition)}</div>
                        <div className="author">{bookInfo.author}</div>
                        <div className="price">{bookInfo.price.FormattedPrice}</div>
                        <div className="justification"><b>Justification:</b> {requestInfo.justification}</div>
                    </div>
                </div>
                <ApprovalStatus isAdmin={isAdmin} requestId={requestInfo.requestId}/>
                <div className="status">
                    Request Status: {requestInfo.requestStatus}
                </div>
                {renderLatestMessage()}
            </Link>
        );
    }
}

RequestSummary.propTypes = {
    isAdmin: React.PropTypes.bool
};
RequestSummary.defaultPropTypes = {
    isAdmin: false
};

export default RequestSummary;



/** WEBPACK FOOTER **
 ** ./src/components/RequestSummary/RequestSummary.js
 **/